<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height:54px;line-height:54px;">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png">
        <span>财务管理</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div class="item" v-for="(item,index) in infoList" :key="index" @click="handleClick(item)">
        <a>
          <img :src="item.img">
          <h5 style="font-size:16px;">{{ item.title }}</h5>
          <span>{{ item.text }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "ChargeManagement",
  data() {
    return {
      chargeManagement: {
        feeSettlementManagement: "费用结算管理",
        title_1: "费用类别管理",
        title_2: "套餐管理",
        title_3: "缴费记录单",
        title_4: "人员类别管理",
        title_5: "人员类别减免",
        title_6: "其他缴费记录单",
        title_7: "每月费用预缴",
        title_8: "费用结算",
        title_9: "服务费用统计",
        text_1: "养老院在经营过程中发生的各项耗费",
        text_2: "养老院针对老人的服务套餐项",
        text_3: "老人在院期间缴纳金额的记录明细",
        text_4: "对特殊情况老人消费减轻免除的管理",
        text_5: "对特殊情况老人消费减轻免除的记录",
        text_6: "其他人员类别的缴费单",
        text_7: "每月需要缴纳的费用",
        text_8: "老人的费用的充值",
        text_9: "服务费用的数据统计"
      },//引入 lang 里面的字符串资源
      infoList: [],//数据源
    }
  },
  methods: {
    //点击每个
    handleClick(item) {
      bus.$emit("homePage", {
            type: "jump",
            path: item.url,
            title: item.title
          });
    },

    /**
     * 获取菜单栏的数据列表
    */
    getPageData() {
      var infoList = [
        {
          url: '/financeView',
          img: require("@/assets/beadhouse/CloseFee.png"),
          title: "财务报表",
          text: "通过报表形式展示机构的财务情况",
          uid: 0
        },
        {
          url: '/ChargeCategoryManagement',
          img: require("@/assets/beadhouse/ChargeCategoryManagement.png"),
          title: this.chargeManagement.title_1,
          text: this.chargeManagement.text_1,
          uid: 1
        }, 
         {
          url: '/PaymentRecord',
          img: require("@/assets/beadhouse/PaymentRecord.png"),
          title: this.chargeManagement.title_3,
          text: this.chargeManagement.text_3,
          uid: 3
        }, {
          url: '/PersonCategoryManagement',
          img: require("@/assets/beadhouse/PersonCategoryManagement.png"),
          title: this.chargeManagement.title_4,
          text: this.chargeManagement.text_4,
          uid: 4
        }, {
          url: '/ArrearageList',
          img: require("@/assets/beadhouse/PersonCategoryReduction.png"),
          title: "余额管理",
          text: "查看老人的余额情况,并能充值余额",
          uid: 5
        }, 
        // {
        //   url: '/OtherPaymentRecord',
        //   img: require("@/assets/beadhouse/OtherPaymentRecord.png"),
        //   title: this.chargeManagement.title_6,
        //   text: this.chargeManagement.text_6,
        //   uid: 6
        // }, 
        // {
        //   url: '/CloseFee',
        //   img: require("@/assets/beadhouse/CloseFee.png"),
        //   title: this.chargeManagement.title_7,
        //   text: this.chargeManagement.text_7,
        //   uid: 7
        // }, {
        //   url: '/CostListLeyi',
        //   img: require("@/assets/beadhouse/CostListLeyi.png"),
        //   title: this.chargeManagement.title_8,
        //   text: this.chargeManagement.text_8,
        //   uid: 8
        // }, 
      ];
      this.infoList = infoList;
    }
  },
  created() {
    this.getPageData();
  },
  mounted() {

  },
}
</script>
<style lang="scss" scoped>
.public_bg {
  width: 100%;
  padding: 0 0 20px 0;
  height: 95%;
  background: #FEFEFE;

  .nurse_top {
    border: 1px #F1EFF2 solid;
    background: #F9F7FA;
    position: relative;

    img {
      margin: 14px 12px;
    }

    h5 {
      display: inline-block;
      position: absolute;
      top: 12px;
      font-size: 18px;
    }
  }

  .row_link {
    width: 1259px;
    margin: 34px 35px;

    .item {
      width: 275px;
      height: 99px;
      border: #F0F0F2 1px solid;
      margin-bottom: 34px;
      margin-right: 34px;
      float: left;
      cursor: pointer;

      img {
        float: left;
        margin: 8px 23px 8px 33px;
        margin-right: 16px;
      }

      span {
        color: #666666;
      }

      h5 {
        margin-top: 21px;
        margin-bottom: 8px;
      }

      a:hover {
        color: #333;
      }
    }

    .item:hover {
      border: 1px solid red;
    }
  }
}</style>
